
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    Users,
    Briefcase,
    LogOut,
    LayoutDashboard,
    MessageSquare,
    UserPlus,
    Share2,
    ListTodo,
    UserCog,
    BarChart3,
    X
} from 'lucide-react';
import { motion } from 'framer-motion';

export default function AdminSidebar({ isOpen, onClose }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            localStorage.removeItem('admin_token');
            navigate('/admin/auth/login');
        }
    };

    const navItems = [
        { path: '/admin/dashboard', name: 'Dashboard', icon: LayoutDashboard },
        { path: '/admin/leads', name: 'Leads', icon: UserPlus },
        { path: '/admin/referral-sources', name: 'Referral Sources', icon: Share2 },
        { path: '/admin/tasks', name: 'Tasks', icon: ListTodo },
        { path: '/admin/users', name: 'Users', icon: UserCog },
        { path: '/admin/referrals', name: 'Original Referrals', icon: Users },
        { path: '/admin/services', name: 'Services', icon: Briefcase },
        { path: '/admin/contacts', name: 'Contacts', icon: MessageSquare },
        { path: '/admin/reports', name: 'Reports', icon: BarChart3 },
    ];

    return (
        <aside className={`
            fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 flex flex-col transition-transform duration-300 ease-in-out lg:translate-x-0
            ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}>
            <div className="p-6 border-b border-gray-100 flex items-center justify-between">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                    Admin Panel
                </h2>
                <button 
                    onClick={onClose}
                    className="p-2 text-gray-500 hover:bg-gray-100 rounded-lg lg:hidden"
                >
                    <X size={20} />
                </button>
            </div>

            <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        onClick={() => {
                            if (window.innerWidth < 1024) onClose();
                        }}
                        className={({ isActive }) => `
                            flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200
                            ${isActive
                                ? 'bg-blue-50 text-blue-700 font-semibold shadow-sm'
                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                            }
                        `}
                    >
                        <item.icon className="w-5 h-5" />
                        <span>{item.name}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-xl transition-colors"
                >
                    <LogOut className="w-5 h-5" />
                    <span>Logout</span>
                </button>
            </div>
        </aside>
    );
}
